import mock from './mock';

const users= [
    {
        nome: 'Lucas Karr Osielski',
        cpf: '050.153.720-19',
        celular: '(51)99898-8470',
        email: 'lucaskarr7@gmail.com',
    },
    {
        nome: 'Emanuel Leonardo Samuel Pires',
        cpf: '813.047.025-02',
        celular: '(46) 98728-3938',
        email: 'emanuel@gmail.com',
    },
    {
        nome: 'Roberto Luís Nicolas Fernandes',
        cpf: '359.326.063-80',
        celular: '(84) 99778-8525',
        email: 'rroberto@gmail.com',
    },
]

// ----------------------------------------------------------------------

mock.onGet('/api/autenticacao/user').reply((config) => {
    try {
      const { cpf } = config.params;
      const user = users.find((user) => user.cpf === cpf);
      if(user){
        return [200, { user }];
      }else{
        return [200, false];
      }
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });